import type { SyncStatus } from "../api/taskApi";

interface SyncIndicatorProps {
  status: SyncStatus;
  onSyncNow(): void;
}

export function describeSync(status: SyncStatus): { label: string; tone: string } {
  switch (status.state) {
    case "idle":
      return { label: "Not synced yet", tone: "idle" };
    case "syncing":
      return { label: "Syncing…", tone: "syncing" };
    case "synced":
      return { label: `Synced ${status.at.toLocaleTimeString([], { timeStyle: "short" })}`, tone: "synced" };
    case "offline":
      return { label: "Offline, changes are kept", tone: "offline" };
  }
}

export function SyncIndicator({ status, onSyncNow }: SyncIndicatorProps) {
  const { label, tone } = describeSync(status);
  const detail = status.state === "offline" ? status.reason : undefined;
  return (
    <button
      type="button"
      className="sync-indicator"
      onClick={onSyncNow}
      title={detail ?? "Sync now"}
      aria-label={`${label}. Sync now`}
    >
      <span className={`sync-dot ${tone}`} aria-hidden="true" />
      <span role="status">{label}</span>
    </button>
  );
}
